import { ApiError } from '@anm/api';
import {
  CurrentWaveEventParams,
  WaveEvent,
  WaveEventItem,
  WaveEventListParams
} from '@anm/api/modules/waveEvents';

import { createAction, ActionUnion } from '../../helpers/createAction';

export const UPDATE_CURRENT_WEEK = 'wave.video/UPDATE_CURRENT_WEEK';
export const FETCH_WAVE_EVENT_LIST = 'wave.video/FETCH_WAVE_EVENT_LIST';
export const WAVE_EVENT_LIST_ERROR = 'wave.video/WAVE_EVENT_LIST_ERROR';
export const WAVE_EVENT_LIST_REQUEST = 'wave.video/WAVE_EVENT_LIST_REQUEST';
export const WAVE_EVENT_LIST_SUCCESS = 'wave.video/WAVE_EVENT_LIST_SUCCESS';

export const FETCH_CURRENT_WAVE_EVENT = 'wave.video/FETCH_CURRENT_WAVE_EVENT';
export const GET_CURRENT_WAVE_EVENT_ERROR =
  'wave.video/GET_CURRENT_WAVE_EVENT_ERROR';
export const GET_CURRENT_WAVE_EVENT_REQUEST =
  'wave.video/GET_CURRENT_WAVE_EVENT_REQUEST';
export const GET_CURRENT_WAVE_EVENT_SUCCESS =
  'wave.video/GET_CURRENT_WAVE_EVENT_SUCCESS';
export const SET_CURRENT_TEMPLATE_FROM_WAVE_EVENT =
  'wave.video/SET_CURRENT_TEMPLATE_FROM_WAVE_EVENT';

export const waveEventsActions = {
  updateCurrentWeek: (startWeekDate: string, endWeekDate: string) =>
    createAction(UPDATE_CURRENT_WEEK, { startWeekDate, endWeekDate }),

  fetchWaveEventList: (weekDate?: string) =>
    createAction(FETCH_WAVE_EVENT_LIST, { weekDate }),
  getWaveEventList: (params?: WaveEventListParams) =>
    createAction(WAVE_EVENT_LIST_REQUEST, params),
  getWaveEventListError: (error: ApiError) =>
    createAction(WAVE_EVENT_LIST_ERROR, error),
  getWaveEventListSuccess: (list: WaveEventItem[], count: number) =>
    createAction(WAVE_EVENT_LIST_SUCCESS, { list, count }),

  fetchWaveEvent: (weekDate: string, waveEventId: string) =>
    createAction(FETCH_CURRENT_WAVE_EVENT, { weekDate, waveEventId }),
  getCurrentWaveEvent: (params: CurrentWaveEventParams) =>
    createAction(GET_CURRENT_WAVE_EVENT_REQUEST, params),
  getCurrentWaveEventError: (error: ApiError) =>
    createAction(GET_CURRENT_WAVE_EVENT_ERROR, error),
  getCurrentWaveEventSuccess: (template: WaveEvent) =>
    createAction(GET_CURRENT_WAVE_EVENT_SUCCESS, template),
  setCurrentTemplateFromWaveEvent: (weekDate: string, waveEventId: string) =>
    createAction(SET_CURRENT_TEMPLATE_FROM_WAVE_EVENT, {
      weekDate,
      waveEventId
    })
};

export type WaveEventsActions = ActionUnion<typeof waveEventsActions>;
